/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 */

import { Component, OnInit,ElementRef,Input,AfterViewInit,Output, EventEmitter, ViewEncapsulation} from '@angular/core';
import { ControlBaseComponent } from "../control-base.component";
import { TimerService } from 'src/refresh/service/timer-service';

@Component({
  selector: 'ng-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class RadioComponent extends ControlBaseComponent implements OnInit,AfterViewInit {

      private static id_no:number = 1;
      constructor( private elRef:ElementRef,protected timerService:TimerService) { 
            super(timerService,5);
      }

      @Input() name: string;
      @Input('item-list') dataList: Map<string,string>;

     //@Output('change')  : works

      public get inputClass():string {
             return "ontario-radios__input " + this.input_class;
      }

      public get labelClass():string {
             return "ontario-fieldset__legend " + this.label_class;
      }

      public get className():string {
             return this.class_name;
      }


      public ngOnInit(): void {
            
            this.textClass = "ontario-text";

            if ( this.input_class.indexOf("light-box") >= 0 ) {
                 this.textClass += " light-box";     
            }

            if ( !this.id ) {
                  this.id =  "radio_"+RadioComponent.id_no++;
            }

            if ( !this.name ) {
                  this.name = "radio_"+this.id;
            }

            if ( this.input === undefined ) this.input = "";

            super.errorParamSet();

            this.update();
      }
      
      labelDivs:any[] = [];

      public ngAfterViewInit() {

            let radioGroupDiv = this.elRef.nativeElement.querySelector('.h-direction');

            let  parent   = radioGroupDiv.parentElement.parentElement;
            let  vertical = parent.parentElement.getAttribute("vertical");
            if ( vertical != null && vertical !==  'false') radioGroupDiv.classList.remove("h-direction");
            super.layoutFromViewInit(parent);

            this.disable = this._disable;
      }

      @Input('ng-disable') set  disable(value:boolean) {

            this._disable = value;

            this.labelDivs.forEach( (labelDiv) => {
                  if ( labelDiv ) {
                        if ( value ) {
                             labelDiv.style.opacity = 0.8;
                        }
                        else labelDiv.style.opacity = 1;
                  }
            });
     }

      get disable():boolean {
              return this._disable;
      }


      private eventClicked:boolean = false;
      @Input ('ng-model')  set input( value: any) {
            
            this._inputX = value;

            if ( this.eventClicked ) {
                 this.eventClicked = false;
                 return;
            }

            let holder = this.getHolder();
            
            for ( let i = 0; i < holder.childNodes.length; i++ ) {
                  
                  let child = holder.childNodes[i].childNodes[0];
                   
                  if ( !value && value != 0 ) child.checked = false;
                  else                        child.checked =  (value == child.value);
            }
      }

      get input() {
          return this._inputX;
      }

      public update()  {

              let holder = this.getHolder();

              while ( holder.childNodes.length > 0 ) {
                      holder.removeChild(holder.childNodes[0]);
              }

              let idx = 0;
              this.dataList.forEach( (value,key) => {
                   holder.appendChild(this.getRadioDom(key,value,idx++));
              });
              
      }

      private getRadioDom(theKey:string, theValue:string,idx:number) {

            let cid = this.name + "_" + idx;
            let div = document.createElement("DIV");
                div.classList.add("ontario-radios__item");
                div.appendChild( this.create(theKey,cid) );

            this.labelDivs.push(div);
 
            let label = document.createElement("LABEL");
                
                label.appendChild(document.createTextNode(theValue));
                label.setAttribute("for",cid);
                label.style.padding = "0.05em 0.6em 0 0.4em";

                label.className = this.textClass;

                
                //if ( this._disable ) {
                //     label.className  +=" label-disabled"; 
               // }
                 

                if ( this.textStyle ) {
                     label.setAttribute("style",this.textStyle);
                }


            div.appendChild(label);

            return div;
      }

      private create(theKey:string,cid:string): any {

            let elem = document.createElement("input");
                elem.setAttribute("type","radio");
                elem.setAttribute("value",theKey);
                elem.setAttribute("name",this.name);
                elem.setAttribute("aria-describedby", "error_"+this.name);
                elem.className = this.inputClass;
                elem.id = cid;

                if ( this._inputX === theKey ) {
                      elem.checked = true;
                }

                if ( this._disable ) {
                     elem.disabled = true;
                }

                if ( this.inputStyle ) {
                     elem.setAttribute("style",this.inputStyle);
                }

                elem.onclick =  ( () => {
                       if ( this._inputX !== theKey ) {
                            this.eventClicked = true;
                            this._inputX = theKey;
                            super.valueChanged();
                       }
                });

            return elem;
      }
      

      private getHolder():any {
            let firstChild = this.elRef.nativeElement.childNodes[0];
            let children   = firstChild.childNodes[0].childNodes;
            return children[2];
      }


}
